export enum AvailabilityStatusEnums {
  INDIFFERENT = 0,
  AVAILABLE = 1,
  NOT_AVAILABLE = 2,
}
